module.exports = __webpack_public_path__ + "static/img/describe.3ac69fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/index1/describe.png
// module id = IvZR
// module chunks = 7